// extracted by mini-css-extract-plugin
export var wordContainer = "_pk-0";